export const types = {
  CREATING_AGREEMENTPAY: "CREATING_AGREEMENTPAY",
  CREATE_AGREEMENTPAY_SUCCESS: "CREATE_AGREEMENTPAY_SUCCESS",
  CREATE_AGREEMENTPAY_FAIL: "CREATE_AGREEMENTPAY_FAIL",
  UNBINDING_AGREEMENTPAY: "UNBINDING_AGREEMENTPAY",
  UNBINDING_AGREEMENTPAY_SUCCESS: "UNBINDING_AGREEMENTPAY_SUCCESS",
  UNBINDING_AGREEMENTPAY_FAIL: "UNBINDING_AGREEMENTPAY_FAIL",
  CLEAR_AGREEMENTPAY: "CLEAR_AGREEMENTPAY",
};
